import { environment } from '../../environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import * as _ from 'lodash';
import { Injectable } from '@angular/core';

import { ICompany } from './company.model';
import { IUserInfo ,AuthService} from '../shared/core/index';
import { IContact } from './contact.model';
import { IAddressBookSearchData } from './address-book-search-data.model';
import { HttpService } from '../shared/core/http.service';

@Injectable()
export class AddressBookService {

    private _userInfo: IUserInfo;
    private _addressBookUrl = new URL('addressbook', environment.apiUrl).toString();
    private _companyUrl = new URL('addressbook/company', environment.apiUrl).toString();

    constructor(private _httpService: HttpService, private _authService: AuthService) {
        this._authService.subscribeToLoginService().subscribe(r => { this._userInfo = r });
    }
    searchCompany(searchData: IAddressBookSearchData): Observable<IAddressBookSearchData> {
        
        console.log('calling searchCompany() from ' + this._addressBookUrl);
        var body = JSON.stringify(searchData);
        return this._httpService.httpPost(this._addressBookUrl, body).pipe(
            map((response) => {
                return this.mapListSearchData(response);
            }),
            tap(data => data),
            catchError(this.handleError)
        );
    }
    getCompanies(searchData: IAddressBookSearchData): Observable<IAddressBookSearchData> {

        console.log('calling getCompanies() from ' + this._addressBookUrl);
        var body = JSON.stringify(searchData);
        return this._httpService.httpPost(this._addressBookUrl, body).pipe(
            map((response) => {
                return this.mapListSearchData(response);
            }),
            tap(data => data),
            catchError(this.handleError)
        );
    }
    mapListSearchData(response: any): IAddressBookSearchData {
        var ret = this.toListSearchData(response);
        return ret;
    }
    toListSearchData(data: any): IAddressBookSearchData {
        if (data) {
            console.log(data);
            let listSearchData: IAddressBookSearchData = new IAddressBookSearchData();
            listSearchData.filterString = data.FilterString;
            listSearchData.pageStartIndex = data.PageStartIndex;
            listSearchData.pazesize = data.Pazesize;
            listSearchData.resultSet = data.ResultSet;
            listSearchData.sortBy = data.SortBy;
            listSearchData.sortOrder = data.SortOrder;
            listSearchData.totalNumberOfRecords = data.TotalNumberOfRecords;
            listSearchData.resultSet = [];
            if (data.ResultSet) {
                data.ResultSet.forEach(element => {
                    try {
                        listSearchData.resultSet.push(this.toCompany(element));
                    } catch (mapErr) {
                        console.error('AddressBookService.toListSearchData >> skipped company due to map error:', mapErr, element);
                    }
                });
            }
            return listSearchData;
        }
    }
    getCompany(searchData: IAddressBookSearchData): Observable<IAddressBookSearchData> {

        return this.getCompanies(searchData);
    }

    saveCompany(company: ICompany): Observable<ICompany> {

        if (company.id) {
            return this.updateCompany(company);
        }
        return this.createCompany(company);
    }

    createCompany(company: ICompany): Observable<ICompany> {

        var companyCopy: ICompany;

        companyCopy = JSON.parse(JSON.stringify(company));

        console.log('calling createCompany() at ' + this._companyUrl + ' for company: ' + JSON.stringify(companyCopy));

        var body = JSON.stringify(companyCopy);

        if(body.indexOf("<") !== -1 || body.indexOf(">") !== -1){
            console.log('AntiXssMiddleware angled brackets ("<", ">") in your input(s).');
            return throwError(() => "AntiXssMiddleware");
        }

        return this._httpService.httpPost(this._companyUrl, body).pipe(
            map((p) => this.toCompany(p)),
            catchError(this.handleError));

    }

    updateCompany(company: ICompany): Observable<ICompany> {

        var companyCopy: ICompany;

        companyCopy = JSON.parse(JSON.stringify(company));

        console.log('calling updateCompany() at ' + this._companyUrl + ' for company: ' + JSON.stringify(companyCopy));

        var body = JSON.stringify(companyCopy);

        if(body.indexOf("<") !== -1 || body.indexOf(">") !== -1){
            console.log('AntiXssMiddleware angled brackets ("<", ">") in your input(s).');
            return throwError(() => "AntiXssMiddleware");
        }

        return this._httpService.httpPut(this._companyUrl, body).pipe(
            map((p) => this.toCompany(p)),
            catchError(this.handleError)
        );

    }

    deleteCompany(id: string): Observable<boolean> {

        if (!id) {
            console.error('cannot delete an empty company, try passing the id...');
            return of(false);
        }

        let url = new URL(id, this._companyUrl + '/').toString();
        console.log('companyService.deleteCompany() at ' + url + ' for company: ' + JSON.stringify(id));

        return this._httpService.httpDelete(url).pipe(
            map((p: any) => {
                //let body= p.json();
                //return body || {}
                console.log('deleteCompany');
                return true;
            }),
            catchError(this.handleError)
        );

    }

    mapCompanies(response: any): ICompany[] {
        
        var ret = response.Companies.map(r => this.toCompany(r));
        console.log('companyService.mapcompanys(...) >> company after mapping:' + JSON.stringify(ret));
        return ret;
    }

    toCompany(r: any): ICompany {
        let company = <ICompany>
            ({
                id: r.Id,
                name: r.Name,
                isSelected: false,
                notes: r.Notes
            });
        company.contacts = new Array<IContact>();

        // Normalize Contacts: API may omit it or return a non-array (breaks forEach → empty UI).
        const rawContacts = r.Contacts;
        const contactsList: any[] = Array.isArray(rawContacts)
            ? rawContacts
            : (rawContacts ? [rawContacts] : []);

        //'clean' the first contact if it's the placeholder 
        if (contactsList.length == 1){
            if (contactsList[0].Name === '[Default]'){
                contactsList[0].Name = '';
            }
        }

        contactsList.forEach(contact => {
            let item = this.toContact(contact);
            if (contact.IsDefault){
                company.defaultContact = this.toContact(contact);
            }
            company.contacts.push(item);
        });

        // Fallback: some payloads expose DefaultCompanyContact without Contacts[] entries.
        if (!company.defaultContact && r.DefaultCompanyContact) {
            company.defaultContact = this.toContact(r.DefaultCompanyContact);
            if (company.contacts.length === 0) {
                company.contacts.push(company.defaultContact);
            }
        }

        console.log('companyService.toCompany(..) >>> ret company: ' + JSON.stringify(company));

        return company;
    }
    toContact(c: any): IContact{
        let contact = <IContact>({
            id: c.Id,
            name: c.Name,
            contactTitle: c.ContactTitle,
            address: c.Address,
            address2: c.Address2,
            city: c.City,
            state: c.State,
            zipCode: c.ZipCode,
            country: c.Country,
            phoneNumber: c.PhoneNumber,
            phoneNumber2: c.PhoneNumber2,
            phoneNumber3: c.PhoneNumber3,                        
            cellNumber: c.CellNumber,
            faxNumber: c.FaxNumber,
            email: c.Email,
            notes: c.Notes,
            isDefault: c.IsDefault,
        });
        return contact;
    }
    getFilters(): any {
        return {};
    }

    private handleError(error: any) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error('companyService.handleError(...() >>> There has been an error while calling api, error:', error);
        return throwError(() => error || 'Server error');
    }
}
